import { Component, Inject, PLATFORM_ID, Renderer2 } from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthService } from './service/auth.service';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router, RouterState } from '@angular/router';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { environment } from '../environments/environment';
declare let gtag: Function;
const gaTag = environment.gaTag;
const isProduction = environment.production;

export interface AppConfig {
  inputStyle?: string;
  dark?: boolean;
  theme?: string;
  ripple?: boolean;
}
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent {
  basicData: any;
  display = true
  is_logged = false
  sidebarExpanded = true;
  basicOptions: any;

  multiAxisData: any;

  chartOptions: any;

  multiAxisOptions: any;

  stackedData: any;

  stackedOptions: any;

  horizontalOptions: any;

  subscription: Subscription | undefined;

  config: AppConfig | any;

  constructor(
    public authservic: AuthService,
    private router: Router,
    private renderer: Renderer2,
    private titleService: Title,
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    if (isPlatformBrowser(this.platformId)) {
      this.injectScripts();
    }
    this.handleRouteEvents();
  }

  injectScripts() {
    const script = this.renderer.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://www.googletagmanager.com/gtag/js?id=' + gaTag;
    this.renderer.appendChild(this.document.body, script);

    const scriptBody = this.renderer.createElement('script');
    scriptBody.type = 'text/javascript';
    scriptBody.text = `window.dataLayer = window.dataLayer || [];
        function gtag() { dataLayer.push(arguments); }
        gtag('js', new Date());
  
        gtag('config', '`+ gaTag + `',{
          send_page_view: false
        });`;
    this.renderer.appendChild(this.document.body, scriptBody);
  }

  handleRouteEvents() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const title = this.document.title; //this.getTitle(this.router.routerState, this.router.routerState.root).join('-');
        this.titleService.setTitle(title);
        gtag('event', 'page_view', {
          page_title: title,
          page_path: event.urlAfterRedirects,
          page_location: this.document.location.href
        })
      }
    });
  }

  getTitle(state: RouterState, parent: ActivatedRoute): string[] {
    const data = [];
    if (parent && parent.snapshot.data && parent.snapshot.data['title']) {
      data.push(parent.snapshot.data['title']);
    }
    if (state && parent && parent.firstChild) {
      data.push(...this.getTitle(state, parent.firstChild));
    }
    return data;
  }

  ngOnInit() {
    //       this.basicData = {
    //           labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
    //           datasets: [
    //               {
    //                   label: 'My First dataset',
    //                   backgroundColor: '#42A5F5',
    //                   data: [65, 59, 80, 81, 56, 55, 40]
    //               },
    //               {
    //                   label: 'My Second dataset',
    //                   backgroundColor: '#FFA726',
    //                   data: [28, 48, 40, 19, 86, 27, 90]
    //               }
    //           ]
    //       };

    //       this.multiAxisData = {
    //           labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
    //           datasets: [{
    //               label: 'Dataset 1',
    //               backgroundColor: [
    //                   '#EC407A',
    //                   '#AB47BC',
    //                   '#42A5F5',
    //                   '#7E57C2',
    //                   '#66BB6A',
    //                   '#FFCA28',
    //                   '#26A69A'
    //               ],
    //               yAxisID: 'y',
    //               data: [65, 59, 80, 81, 56, 55, 10]
    //           }, {
    //               label: 'Dataset 2',
    //               backgroundColor: '#78909C',
    //               yAxisID: 'y1',
    //               data: [28, 48, 40, 19, 86, 27, 90]
    //           }]
    //       };

    //       this.multiAxisOptions = {
    //           plugins: {
    //               legend: {
    //                   labels: {
    //                       color: '#495057'
    //                   }
    //               },
    //               tooltips: {
    //                   mode: 'index',
    //                   intersect: true
    //               }
    //           },
    //           scales: {
    //               x: {
    //                   ticks: {
    //                       color: '#495057'
    //                   },
    //                   grid: {
    //                       color: '#ebedef'
    //                   }
    //               },
    //               y: {
    //                   type: 'linear',
    //                   display: true,
    //                   position: 'left',
    //                   ticks: {
    //                       min: 0,
    //                       max: 100,
    //                       color: '#495057'
    //                   },
    //                   grid: {
    //                       color: '#ebedef'
    //                   }
    //               },
    //               y1: {
    //                   type: 'linear',
    //                   display: true,
    //                   position: 'right',
    //                   grid: {
    //                       drawOnChartArea: false,
    //                       color: '#ebedef'
    //                   },
    //                   ticks: {
    //                       min: 0,
    //                       max: 100,
    //                       color: '#495057'
    //                   }
    //               }
    //           }
    //       };

    //       this.horizontalOptions = {
    //           indexAxis: 'y',
    //           plugins: {
    //               legend: {
    //                   labels: {
    //                       color: '#495057'
    //                   }
    //               }
    //           },
    //           scales: {
    //               x: {
    //                   ticks: {
    //                       color: '#495057'
    //                   },
    //                   grid: {
    //                       color: '#ebedef'
    //                   }
    //               },
    //               y: {
    //                   ticks: {
    //                       color: '#495057'
    //                   },
    //                   grid: {
    //                       color: '#ebedef'
    //                   }
    //               }
    //           }
    //       };

    //       this.stackedData = {
    //           labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
    //           datasets: [{
    //               type: 'bar',
    //               label: 'Dataset 1',
    //               backgroundColor: '#42A5F5',
    //               data: [
    //                   50,
    //                   25,
    //                   12,
    //                   48,
    //                   90,
    //                   76,
    //                   42
    //               ]
    //           }, {
    //               type: 'bar',
    //               label: 'Dataset 2',
    //               backgroundColor: '#66BB6A',
    //               data: [
    //                   21,
    //                   84,
    //                   24,
    //                   75,
    //                   37,
    //                   65,
    //                   34
    //               ]
    //           }, {
    //               type: 'bar',
    //               label: 'Dataset 3',
    //               backgroundColor: '#FFA726',
    //               data: [
    //                   41,
    //                   52,
    //                   24,
    //                   74,
    //                   23,
    //                   21,
    //                   32
    //               ]
    //           }]
    //       };

    //       this.stackedOptions = {
    //           tooltips: {
    //               mode: 'index',
    //               intersect: false
    //           },
    //           responsive: true,
    //           scales: {
    //               xAxes: [{
    //                   stacked: true,
    //               }],
    //               yAxes: [{
    //                   stacked: true
    //               }]
    //           }
    //       };

    //       // this.config = this.configService.config;
    //       // this.updateChartOptions();
    //       // this.subscription = this.configService.configUpdate$.subscribe((config: any) => {
    //       //     this.config = config;
    //       //     this.updateChartOptions();
    //       // });
    //   }

    //   updateChartOptions() {
    //       if (this.config.dark)
    //           this.applyDarkTheme();
    //       else
    //           this.applyLightTheme();
    //   }

    //   applyDarkTheme() {
    //       this.basicOptions = {
    //           plugins: {
    //               legend: {
    //                   labels: {
    //                       color: '#ebedef'
    //                   }
    //               }
    //           },
    //           scales: {
    //               x: {
    //                   ticks: {
    //                       color: '#ebedef'
    //                   },
    //                   grid: {
    //                       color: 'rgba(255,255,255,0.2)'
    //                   }
    //               },
    //               y: {
    //                   ticks: {
    //                       color: '#ebedef'
    //                   },
    //                   grid: {
    //                       color: 'rgba(255,255,255,0.2)'
    //                   }
    //               }
    //           }
    //       };

    //       this.horizontalOptions = {
    //           indexAxis: 'y',
    //           plugins: {
    //               legend: {
    //                   labels: {
    //                       color: '#ebedef'
    //                   }
    //               }
    //           },
    //           scales: {
    //               x: {
    //                   ticks: {
    //                       color: '#ebedef'
    //                   },
    //                   grid: {
    //                       color: 'rgba(255,255,255,0.2)'
    //                   }
    //               },
    //               y: {
    //                   ticks: {
    //                       color: '#ebedef'
    //                   },
    //                   grid: {
    //                       color: 'rgba(255,255,255,0.2)'
    //                   }
    //               }
    //           }
    //       };

    //       this.multiAxisOptions = {
    //           plugins: {
    //               legend: {
    //                   labels: {
    //                       color: '#ebedef'
    //                   }
    //               },
    //               tooltips: {
    //                   mode: 'index',
    //                   intersect: true
    //               }
    //           },
    //           scales: {
    //               x: {
    //                   ticks: {
    //                       color: '#ebedef'
    //                   },
    //                   grid: {
    //                       color: 'rgba(255,255,255,0.2)'
    //                   }
    //               },
    //               y: {
    //                   type: 'linear',
    //                   display: true,
    //                   position: 'left',
    //                   ticks: {
    //                       min: 0,
    //                       max: 100,
    //                       color: '#ebedef'
    //                   },
    //                   grid: {
    //                       color: 'rgba(255,255,255,0.2)'
    //                   }
    //               },
    //               y1: {
    //                   type: 'linear',
    //                   display: true,
    //                   position: 'right',
    //                   grid: {
    //                       drawOnChartArea: false,
    //                       color: 'rgba(255,255,255,0.2)'
    //                   },
    //                   ticks: {
    //                       min: 0,
    //                       max: 100,
    //                       color: '#ebedef'
    //                   }
    //               }
    //           }
    //       };

    //       this.stackedOptions = {
    //           plugins: {
    //               legend: {
    //                   labels: {
    //                       color: '#ebedef'
    //                   }
    //               },
    //               tooltips: {
    //                   mode: 'index',
    //                   intersect: false
    //               }
    //           },
    //           scales: {
    //               x: {
    //                   stacked: true,
    //                   ticks: {
    //                       color: '#ebedef'
    //                   },
    //                   grid: {
    //                       color: 'rgba(255,255,255,0.2)'
    //                   }
    //               },
    //               y: {
    //                   stacked: true,
    //                   ticks: {
    //                       color: '#ebedef'
    //                   },
    //                   grid: {
    //                       color: 'rgba(255,255,255,0.2)'
    //                   }
    //               }
    //           }
    //       };
    //   }

    //   applyLightTheme() {
    //       this.basicOptions = {
    //           plugins: {
    //               legend: {
    //                   labels: {
    //                       color: '#495057'
    //                   }
    //               }
    //           },
    //           scales: {
    //               x: {
    //                   ticks: {
    //                       color: '#495057'
    //                   },
    //                   grid: {
    //                       color: '#ebedef'
    //                   }
    //               },
    //               y: {
    //                   ticks: {
    //                       color: '#495057'
    //                   },
    //                   grid: {
    //                       color: '#ebedef'
    //                   }
    //               }
    //           }
    //       };

    //       this.horizontalOptions = {
    //           indexAxis: 'y',
    //           plugins: {
    //               legend: {
    //                   labels: {
    //                       color: '#495057'
    //                   }
    //               }
    //           },
    //           scales: {
    //               x: {
    //                   ticks: {
    //                       color: '#495057'
    //                   },
    //                   grid: {
    //                       color: '#ebedef'
    //                   }
    //               },
    //               y: {
    //                   ticks: {
    //                       color: '#495057'
    //                   },
    //                   grid: {
    //                       color: '#ebedef'
    //                   }
    //               }
    //           }
    //       };

    //       this.multiAxisOptions = {
    //           plugins: {
    //               legend: {
    //                   labels: {
    //                       color: '#495057'
    //                   }
    //               },
    //               tooltips: {
    //                   mode: 'index',
    //                   intersect: true
    //               }
    //           },
    //           scales: {
    //               x: {
    //                   ticks: {
    //                       color: '#495057'
    //                   },
    //                   grid: {
    //                       color: '#ebedef'
    //                   }
    //               },
    //               y: {
    //                   type: 'linear',
    //                   display: true,
    //                   position: 'left',
    //                   ticks: {
    //                       min: 0,
    //                       max: 100,
    //                       color: '#495057'
    //                   },
    //                   grid: {
    //                       color: '#ebedef'
    //                   }
    //               },
    //               y1: {
    //                   type: 'linear',
    //                   display: true,
    //                   position: 'right',
    //                   grid: {
    //                       drawOnChartArea: false,
    //                       color: '#ebedef'
    //                   },
    //                   ticks: {
    //                       min: 0,
    //                       max: 100,
    //                       color: '#495057'
    //                   }
    //               }
    //           }
    //       };

    //       this.stackedOptions = {
    //           plugins: {
    //               tooltips: {
    //                   mode: 'index',
    //                   intersect: false
    //               },
    //               legend: {
    //                   labels: {
    //                       color: '#495057'
    //                   }
    //               }
    //           },
    //           scales: {
    //               x: {
    //                   stacked: true,
    //                   ticks: {
    //                       color: '#495057'
    //                   },
    //                   grid: {
    //                       color: '#ebedef'
    //                   }
    //               },
    //               y: {
    //                   stacked: true,
    //                   ticks: {
    //                       color: '#495057'
    //                   },
    //                   grid: {
    //                       color: '#ebedef'
    //                   }
    //               }
    //           }
    //       };
    //   }
  }
}
